// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3_VMs","description":"PatientConsentPreview_description__2hON5"};